import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { useFraudsScreen } from './useFraudsScreen'

const HiringScreenDesktop = lazy(() => import('../HiringScreen/HiringScreen.desktop'))

const HiringScreenMobile = lazy(() => import('../HiringScreen/HiringScreen.mobile'))

export const FraudsScreen = () => {
  const props = useFraudsScreen()

  const Screen = props.isMobile ? HiringScreenMobile : HiringScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
